export enum PreferenceType {
  FAVORITE = 'FAVORITE',
  MAIN = 'MAIN',
}

export enum ResultsType {
  FAVORITE = 'FAVORITE',
  LOCATION = 'LOCATION',
}

export type Dealer = {
  accountNumber?: string;
  location: Location;
  contact: Contact;
  classifications: Classifications;
  id: string;
  description: string;
  preference?: Preference;
  openingHours: OpeningHours;
  isOpen: boolean;
};

export type Classifications = {
  isIMOWDealer: boolean;
};

export type Contact = {
  website: string;
  landlinePhone: string;
  publicEmail: string;
};

export type Location = {
  addressLines?: string;
  dependentLocality?: string;
  locality?: string;
  administrativeArea?: string;
  country?: string;
  city?: string;
  street1?: string;
  houseNo?: string;
  district?: string;
  region?: string;
  postalCode: string;
  geo: Geo;
  formatted: string;
  googleMapsUrl: string;
  distanceMeters: number;
};

export type Geo = {
  lat: number;
  lng: number;
};

export type OpeningHours = {
  mon?: string[];
  tue?: string[];
  wed?: string[];
  thu?: string[];
  fri?: string[];
  sat?: string[];
};

export type Preference = {
  stihlId: string;
  type: PreferenceType;
  createdAt: string;
};

export type Nps = {
  createdAt: string;
  dealerId: string;
  description: string;
  stihlId: string;
  value: number;
};

export type DealerNpsFormValues = {
  value: string | null;
  description: string;
};

export type DealerDetailsDisplayConfig = {
  preferencesEnabled?: boolean;
  preferencesEditable?: boolean;
  addressEnabled?: boolean;
  phoneNumberEnabled?: boolean;
  distanceEnabled?: boolean;
  planRouteButton?: boolean;
  writeEmailButton?: boolean;
  visitWebsiteButton?: boolean;
  openingHoursEnabled?: boolean;
  openingHoursInitiallyExpanded?: boolean;
  openingHoursHeadline?: boolean;
  npsEnabled?: boolean;
};

export type DealerDetailsProps = {
  displayConfig?: DealerDetailsDisplayConfig;
  isStandalone?: boolean;
  className?: string;
  style?: React.CSSProperties;
  layout?: 'VERTICAL' | 'HORIZONTAL' | 'COMPACT';
  childrenClassName?: string;
};

export type BoundingBox = {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
};

export type DealerSearchQueryObjectType = 'BOUNDING_BOX' | 'REFERENCE' | 'LOCATION';

export type DealerSearchQueryObject =
  | {
      type: DealerSearchQueryObjectType;
      value: BoundingBox;
    }
  | { type: DealerSearchQueryObjectType; value: string; radiusKm?: number }
  | { type: DealerSearchQueryObjectType; value: google.maps.LatLng | string; radiusKm?: number }
  | undefined;

export type UseDealerLocations = {
  dealerSearchQueryObject?: DealerSearchQueryObject;
  selectedFilterOptions?: string[];
};
